import React from "react";
import { useShopModel } from "../shopModel";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
        orgDs, beDs
    } = useShopModel();

    const searchFields = [
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "从属机构",
            fieldName: "orgCode",
            treeDs: orgDs
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联实体",
            fieldName: "bentityCode",
            options: beDs
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "门店名称",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [{ label: "启用", value: "0" }, { label: "禁用", value: "1" }]
        }
    ]

    return (
        <YhPageHeader
            title="门店管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}